export default {
  urls: (hash, hotelSlug) =>
    hotelSlug === 'hotel-catalonia-desarrollo' || hotelSlug === '3250'
      ? {
          logout: `https://test.cataloniahotels.com/es/js/ajax/logout?callback=${hash}`,
          jquery: `https://test.cataloniahotels.com/sites/all/modules/contrib/jquery_update/replace/jquery/1.12/jquery.min.js?v=1.12.4&${hash}`,
          cataloniaForm: `https://test.cataloniahotels.com/sites/all/modules/custom/hcat_user_forms/js/cataloniaForm_pre.js?${hash}`,
          css: `https://test.cataloniahotels.com/sites/all/modules/custom/hcat_user_forms/css/cataloniaForm.css?${hash}`,
          iframe: `https://test.cataloniahotels.com/{lang}/login-popup?${hash}&hotelId={hotelId}&bookingId={bookingId}&position={position}`,
        }
      : {
          logout: `https://www.cataloniahotels.com/es/js/ajax/logout?callback=${hash}`,
          jquery: `https://www.cataloniahotels.com/sites/all/modules/contrib/jquery_update/replace/jquery/1.12/jquery.min.js?v=1.12.4&${hash}`,
          cataloniaForm: `https://www.cataloniahotels.com/sites/all/modules/custom/hcat_user_forms/js/cataloniaForm.js?${hash}`,
          css: `https://www.cataloniahotels.com/sites/all/modules/custom/hcat_user_forms/css/cataloniaForm.css?${hash}`,
          iframe: `https://www.cataloniahotels.com/{lang}/login-popup?${hash}&hotelId={hotelId}&bookingId={bookingId}&position={position}`,
        },
};
